import styled from "styled-components";
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import PaymentIcon from "@mui/icons-material/Payment";

const FooterMetodosPagoContainer = styled((props: any) => <StyledGrid {...props} />)`
  ${({ theme }) => `
  .contenedor_metodos_pago {
    width: 100%;
  }

  .imagen_metodo_de_pago {
    width: 282px;
  }

  .imagen_sello_de_confianza {
    width: 138px;
  }

  @media (min-width: ${theme.breakpoints.values.sm}px) {
    .imagen_metodo_de_pago {
      width: 257px;
    }

    .imagen_sello_de_confianza {
      width: 128px;
    }
  }
`}
`;

export const FooterMetodosPago = () => {
  return (
    <FooterMetodosPagoContainer>
      <StyledGrid className="contenedor_metodos_pago" container xs={12} md={12} lg={12} xl={12}>
        <StyledGrid item xs={12} md={12} lg={12} xl={12}>
          <img
            src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/OnboardStorefrontAssetStore/images-site/payments-footer.png"
            alt="metodo-de-pago.png"
            className="imagen_metodo_de_pago"
          />
        </StyledGrid>
      </StyledGrid>
      <StyledGrid container xs={12} md={12} lg={12} xl={12}>
        <a href="https://sellosdeconfianza.org.mx/MuestraCertificado.php?NUMERO_SERIE=SC_b32">
          <StyledGrid item xs={12} md={12} lg={12} xl={12}>
            <img
              src="https://dq01t193ieeid.cloudfront.net/wcsstore/DportenisStorefrontAssetStore/images/sello_de_confianza.jpg"
              alt="sello-de-confianza.JPG"
              className="imagen_sello_de_confianza"
            />
          </StyledGrid>
        </a>
      </StyledGrid>
    </FooterMetodosPagoContainer>
  );
};
